import React from 'react';
import { useQuery } from '@apollo/client';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import CalendarPicker from '../../../components/CalendarPicker';
import BillingAddress from '../../../components/V2/BillingAddress';
import DeliveryDay from '../UserManagementPage/DeliveryDay';
import ProgramDetails from './components/ProgramDetails';
import { FETCH_USER_DELIVERY_SKIPS, GET_PROGRAM_DETAIL } from 'core/api/apollo/queries';
import { NavigationHeader } from 'onramp/ui/components';
import { Button, Box, Flex, Hr, Text } from 'core/ui/atoms';
import { mySettingsPath } from 'onramp/api/navigation';

const MyProgramPage = () => {
  const history = useHistory();
  const { data: { fetchUserDeliverySkips = [] } = [], refetch: refetchSkips } = useQuery(FETCH_USER_DELIVERY_SKIPS);

  const { loading: programLoading, error: programError, data: { getProgramDetail = {} } = {} } = useQuery(GET_PROGRAM_DETAIL);

  const onSettingsNavigate = () => {
    history.push(mySettingsPath());
  };

  const isSubscription = getProgramDetail?.subscriptionActive;
  const daysPerWeek = getProgramDetail?.programBundle?.schedule?.daysOfWeek?.length;

  return (
    <Box>
      <NavigationHeader title='My Program' />
      <Hr />
      <Content>
        <Title>My Program Details</Title>
        <ProgramDetails
          getProgramDetail={getProgramDetail}
          programLoading={programLoading}
          programError={programError}
        />
        {isSubscription && <FlexRowContainer direction='row' alignItems='center' justifyContent='center'>
          <SubscriptionButton btn-outline onClick={onSettingsNavigate}>
            <Text>MANAGE MY SUBSCRIPTION</Text>
          </SubscriptionButton>
        </FlexRowContainer>}
        <Hr />
        <CalendarContainer>
          <Title>My Calendar</Title>
          <SubTitle>Select a week to skip or edit your program</SubTitle>
          <CalendarPicker
            daysPerWeek={daysPerWeek}
            refetchSkips={refetchSkips}
            deliverySkips={fetchUserDeliverySkips}
          />
        </CalendarContainer>
        <Hr />
        <AddressContainer>
          <Title>Default Delivery Address</Title>
          <BillingAddress />
        </AddressContainer>
      </Content>
      <DeliveryDay />
    </Box>
  );
};

const FlexRowContainer = styled(Flex)`
  margin-top: 36px;
  margin-bottom: 44px;
`;

const SubscriptionButton = styled(Button)`
  width: 320px;
  height: 43px;
  padding: 10px 32px;
  gap: 10px;
  border-radius: 4px;
  p {
    margin: 0px;
    font-size: 12px;
    text-transform: uppercase;
    font-family: ${({ theme }) => theme.typography.familyPoppins};
    color: ${(p) => p.theme.colors.primaryV2};
  }
`;

const AddressContainer = styled(Box)`
`;

const SubTitle = styled(Text)`
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  text-align: center;
  margin-top: 0px;
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  color: ${(p) => p.theme.colors.primaryV2};
`;

const CalendarContainer = styled(Box)`
  margin-bottom: 30px;
`;

const Content = styled(Box)`
  padding-left: 16px;
  padding-right: 16px;
`;

const Title = styled(Text)`
  text-align: center;
  font-size: 22px;
  font-weight: 400;
  line-height: 28px;
  font-family: ${({ theme }) => theme.typography.familyLarken};
  color: ${(p) => p.theme.colors.primaryV2};
`;

export default MyProgramPage;
